<template>
  <div>
    <div v-if="!isMobile">
      <Header />
      <TitlePage />
      <div class="content-seller-detail">
        <b-container fluid="xl">
          <b-row>
            <b-row class="justify-content-between w-100">
              <h4 style="color:var(--projectPrimaryColor)">{{hotDeals?hotDeals.name:''}}</h4>
              <b-dropdown class="menu-dropdown hide-advance" id="hide-advance" v-model="listing_category_id" no-flip >
                <template v-slot:button-content>
                  <span>
                    <template v-if="listing_category_id == 1">
                      {{ $t("categories.market.market") }}
                    </template>
                    <template v-if="listing_category_id == 2">
                      {{ $t("categories.realEstate.realEstate") }}
                    </template>
                    <template v-if="listing_category_id == 3">
                      {{ $t("categories.carsEngines.carsEngines") }}
                    </template>
                    <template v-if="listing_category_id == 4">
                      {{ $t("categories.findAJob.findAJob") }}
                    </template>
                    <template v-if="!listing_category_id">
                      {{ $t("specialDeal.sortBy") }}
                    </template>
                    <ChevronDownIcon />
                  </span>
                </template>
                <b-dropdown-item
                  @click.native="listing_category_id = 1"
                  >{{  $t("categories.market.market") }}</b-dropdown-item
                >
                <b-dropdown-item @click.native="listing_category_id = 2">{{
                  $t("categories.realEstate.realEstate")
                }}</b-dropdown-item>
                <b-dropdown-item
                  @click.native="listing_category_id = 3"
                  >{{ $t("categories.carsEngines.carsEngines") }}</b-dropdown-item
                >
                <b-dropdown-item
                  @click.native="listing_category_id = 4"
                  >{{ $t("categories.findAJob.findAJob") }}</b-dropdown-item
                >
              </b-dropdown>
            </b-row>
            <b-col cols="12" class="seller-detail-card">
              <b-row>
                <b-col cols="12" class="pd-0">
                  <div class="wrapper" v-if="specialDealListing.listings.length">
                    <div class="item" v-for="(listing, key) in specialDealListing.listings" :key="key">
                      <Card
                        v-if="!listing.isCardFeature"
                        :color="'bg-yellow'"
                        :showNegotiable="true"
                        :price="listing.price"
                        :title="listing.title"
                        :province="listing.province.name"
                        :district="listing.district.name"
                        :urlImage="listing.url_feature_image"
                        :id="listing.id"
                        :listingPremium="listing.listing_premiums"
                        :agency_profile_image="listing.agency_profile_image"
                        :url="listing.site==2?listing.url:null"
                      />
                    </div>
                  </div>
                  <b-row v-else class="w-100 justify-content-center align-items-center align-self-center">
                    {{$t('userDashboard.messages.emptyData')}}
                  </b-row>
                </b-col>
              </b-row>
              <b-row cols="12" lg="12" class="text-center paginate-position" v-if="specialDealListing.listings.length">
                    <div class="overflow-auto wrap-pagination d-none d-md-block">
                      <b-pagination-nav
                        v-model="page"
                        class="paginate-item"
                        :prev-text="$t('nextPg')"
                         :next-text="$t('prevPg')"
                        :link-gen="paginationNumber"
                        :number-of-pages="specialDealListing.meta  && specialDealListing.meta.pageCount ? specialDealListing.meta.pageCount : 1"
                        use-router
                      ></b-pagination-nav>
                    </div>
                  </b-row>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <Footer />
    </div>
    <div v-if="isMobile">
      <Header />
      <TitlePage />
      <div class="content-seller-detail mb-content-seller-detail">
        <b-container fluid="xl">
          <b-row>
            <b-col cols="12">
              <div class="wrap-listing">
                <b-row class="justify-content-between w-100 m-0">
                  <h4 style="color:var(--projectPrimaryColor)">{{hotDeals?hotDeals.name:''}}</h4>
                  <b-dropdown class="menu-dropdown hide-advance m-0 mb-3" id="hide-advance" v-model="listing_category_id" no-flip >
                    <template v-slot:button-content>
                      <span>
                        <template v-if="listing_category_id == 1">
                          {{ $t("categories.market.market") }}
                        </template>
                        <template v-if="listing_category_id == 2">
                          {{ $t("categories.realEstate.realEstate") }}
                        </template>
                        <template v-if="listing_category_id == 3">
                          {{ $t("categories.carsEngines.carsEngines") }}
                        </template>
                        <template v-if="listing_category_id == 4">
                          {{ $t("categories.findAJob.findAJob") }}
                        </template>
                        <template v-if="!listing_category_id">
                          {{ $t("specialDeal.sortBy") }}
                        </template>
                        <ChevronDownIcon />
                      </span>
                    </template>
                    <b-dropdown-item
                      @click.native="listing_category_id = 1"
                      >{{  $t("categories.market.market") }}</b-dropdown-item
                    >
                    <b-dropdown-item @click.native="listing_category_id = 2">{{
                      $t("categories.realEstate.realEstate")
                    }}</b-dropdown-item>
                    <b-dropdown-item
                      @click.native="listing_category_id = 3"
                      >{{ $t("categories.carsEngines.carsEngines") }}</b-dropdown-item
                    >
                    <b-dropdown-item
                      @click.native="listing_category_id = 4"
                      >{{ $t("categories.findAJob.findAJob") }}</b-dropdown-item
                    >
                  </b-dropdown>
                </b-row>
               
                <div class="wrapper" v-if="specialDealListing.listings.length">
                  <div class="item"  v-for="(listing, key) in specialDealListing.listings" :key="key.id">
                    <Card
                     v-if="!listing.isCardFeature"
                      :color="'bg-yellow'"
                      :showNegotiable="true"
                      :price="listing.price"
                      :title="listing.title"
                      :province="listing.province.name"
                      :district="listing.district.name"
                      :urlImage="listing.url_feature_image"
                      :id="listing.id"
                      :listingPremium="listing.listing_premiums"
                      :agency_profile_image="listing.agency_profile_image"
                      :url="listing.site==2?listing.url:null"
                    />
                  </div>
                </div>
                <infinite-loading @infinite="infiniteHandler" ref="infiniteHandler">
                  <span slot="no-results"><b-alert show variant="light" v-if="specialDealListing.listings && !specialDealListing.listings.length">{{$t('userDashboard.messages.emptyData')}}</b-alert></span>
                  <span slot="no-more"></span>
                </infinite-loading>
                
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/ui/header";
import Footer from "@/components/ui/footer";
import TitlePage from "@/components/ui/titlePage";
import Card from "@/components/card";
import InfiniteLoading from 'vue-infinite-loading';
import { mapGetters, mapActions, mapState } from "vuex";
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
export default {
  name: "specialDeals",
  components: {
    Header,
    Footer,
    TitlePage,
    Card,
    InfiniteLoading,
    ChevronDownIcon
  },
  computed: {
    ...mapGetters("UserController", ["isMobile"]),
  },
  data() {
    return {
      page: 1,//this.$route.params.id ? this.$route.params.id : 1,
      limit: 20,
      specialDealListing:{
        listings:[],
        meta:{}
      },
      listing_category_id:null,
      hotDeals:null
    };
  },
  created() {
    this.getspecialDealListing();
  },
  watch: {
    page: function(val) {
      // Call api for Desktop
       if(!this.isMobile) {
        this.getspecialDealListing();
       }
    },
    listing_category_id(val){
        this.getspecialDealListing();
    }
    // specialDealListing: function(arr) {
    //   
    //   this.specialDealListing = JSON.parse(JSON.stringify(arr));
    //   
    // }
  },
  methods: {
    ...mapActions("HomeController", ["GET_LISTING_HOT_DEALS"]),
    // Call api for Mobile,
    getspecialDealListing() {
       this.GET_LISTING_HOT_DEALS({
        take: this.limit,
        page: this.page,
        filter: 'HotDeals',
        listing_category_id: this.listing_category_id,
      })
      .then((item) => {
        console.log("item",item)
        this.specialDealListing.listings=item.data.data.listings;
        this.specialDealListing.meta=item.data.meta;
        this.hotDeals=item.data.data.hot_deal;
        this.$forceUpdate();
          console.log("this.specialDealListing",this.specialDealListing.listings.length)
      })
    },
    async infiniteHandler($state) {
      this.GET_LISTING_HOT_DEALS({
        take: this.limit,
        page: this.page,
        filter: 'HotDeals',
        listing_category_id: this.listing_category_id,
      })
      .then(response => {
        if(!response.data.data) {
          return $state.complete();
        }
        let arrLength = response.data.data.listings.length
        this.specialDealListing.listings=response.data.data.listings;
        this.specialDealListing.meta=response.data.meta;
        this.hotDeals=response.data.data.hot_deal;
        this.$forceUpdate();
        if(arrLength.length < this.specialDealListing.meta.itemCount) {
          this.page += 1
          $state.loaded();
        }
        else $state.complete();
      })
    },
    paginationNumber(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    }
  }
};
</script>
<style lang="scss">
@import "style";
</style>